import React from "react";
import { Box, Text, Heading, Flex } from "@theme-ui/components";
import PropTypes from "prop-types";
import { Icon } from '../atoms';
import { colors, typography } from '../../styles/theme';
import { InfoTile } from '../molecules';

const labelStyle = { ...typography.textSm, color: colors.black };

const TopLabel = ({ publishDate, author }) => {
  return (
    <Text sx={labelStyle}>
      {publishDate} {author && <Text>| {author}</Text>}
    </Text>
  );
};

const BottomLabel = ({ topic }) => (
  <Box>
    <Icon name="Tag" color={colors.black} size={16} />
    <Text sx={{ pl: "0.5rem", ...labelStyle }}>{topic}</Text>
  </Box>
);

const RelatedPostsV2 = ({ blogList, pageContext, isTopLabelRequired }) => {
  const regionPath = pageContext.regionPath ? `/${pageContext.regionPath}` : "";
  return (
    <Box my={["4rem", "4rem", "4rem", "6.25rem"]}>
      <Heading
        as="h2"
        sx={{
          ...typography.h2,
          textAlign: "center",
          mb: ["1.5rem", "1.5rem", "1.5rem", "3rem"],
        }}
      >
        Related Posts
      </Heading>
      <Flex sx={{ justifyContent: "center", flexWrap: "wrap", width: "100%" }}>
        {blogList.map(
          (
            {
              title,
              description,
              slug,
              featuredImage,
              featuredImageAltText,
              author,
              publishDate,
              topics,
            },
            i,
          ) => (
            <InfoTile
              key={`recent-blogs-${i}`}
              image={featuredImage}
              imageAltText={featuredImageAltText}
              title={title}
              content={description}
              topLabel={
                isTopLabelRequired &&
                (publishDate || author?.firstName) && (
                  <TopLabel
                    publishDate={publishDate}
                    author={author?.firstName}
                  />
                )
              }
              bottomLabel={
                topics[0]?.name ? <BottomLabel topic={topics[0]?.name} /> : null
              }
              hasBorder={false}
              url={`${regionPath}/blog/${slug}/`}
              customStyles={{ width: ["100%", "100%", "19rem", "21.375rem"] }}
            />
          ),
        )}
      </Flex>
    </Box>
  );
};

RelatedPostsV2.propTypes = {
  blogList: PropTypes.array,
  pageContext: PropTypes.object,
  isTopLabelRequired: PropTypes.bool,
};

export default RelatedPostsV2;
